import * as tslib_1 from "tslib";
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Selectors } from 'store/root-reducer';
import { Observable, of } from 'rxjs';
import { switchMap, catchError, map, exhaustMap, take, withLatestFrom } from 'rxjs/operators';
import { BillableActionTypes, LoadBillableSuccess, LoadBillableFailure, CheckBalanceSuccess, CheckBalanceFailure } from 'store/actions/billable.actions';
import { BillableService } from 'modules/core/services/billable.service';
import { NoCreditWarningDialogService } from 'modules/shared/components/no-credit-warning-dialog/no-credit-warning-dialog.service';
var BillableEffects = /** @class */ (function () {
    function BillableEffects(store, actions$, billableService, noCreditWarningDialogService) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.billableService = billableService;
        this.noCreditWarningDialogService = noCreditWarningDialogService;
        this.CheckBalance = this.actions$.pipe(ofType(BillableActionTypes.CHECK_BALANCE), map(function (action) { return action.payload; }), withLatestFrom(this.store.select(Selectors.billable.getSubscribedButNoCreditEngines)), exhaustMap(function (_a) {
            var payload = _a[0], noCreditSearchEngines = _a[1];
            var showDialog = false;
            if (payload.searchEnginesToCheck && payload.searchEnginesToCheck.length) {
                showDialog = !!noCreditSearchEngines.filter(function (noCreditSearchEngine) {
                    return payload.searchEnginesToCheck
                        .map(function (searchEngineToCheck) { return searchEngineToCheck.toLowerCase(); })
                        .includes(noCreditSearchEngine.toLowerCase());
                }).length;
            }
            else {
                showDialog = !!noCreditSearchEngines.length;
            }
            if (showDialog) {
                return _this.noCreditWarningDialogService
                    .showNoCreditWarning({
                    noCreditSearchEngines: noCreditSearchEngines,
                    hideContinueButton: payload.searchEnginesToCheck && payload.searchEnginesToCheck.length === 1
                })
                    .pipe(take(1), map(function (userDecision) { return ({ userDecision: userDecision, actions: payload.actions }); }));
            }
            else {
                return of({ userDecision: 'continue', actions: payload.actions });
            }
        }), switchMap(function (res) {
            if (res.userDecision === 'continue') {
                return res.actions.concat([new CheckBalanceSuccess()]);
            }
            return [{ type: 'EMPTY' }, , new CheckBalanceFailure()];
        }));
        this.LoadBillable = this.actions$.pipe(ofType(BillableActionTypes.LOAD_BILLABLE), switchMap(function (action) {
            return _this.billableService.getUserBillableInfo().pipe(map(function (bills) { return new LoadBillableSuccess(bills); }), catchError(function (error) { return of(new LoadBillableFailure(error)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], BillableEffects.prototype, "CheckBalance", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], BillableEffects.prototype, "LoadBillable", void 0);
    return BillableEffects;
}());
export { BillableEffects };
